import apiService from "./apiService";

const userService = {
    async signup(userData) {
        try {
            return (await apiService.post(`auth/signup`, userData, false)).data;
        }
        catch {
            return { sucess: false, message: 'An error occured while processing the request.' };
        }
    },

    async activate(code) {
        try {
            return (await apiService.put(`auth/${code}/activate`, {}, true)).data;
        }
        catch {
            return { sucess: false, message: 'An error occured while processing the request.' };
        }
    },
    async requestPasswordResetOTP(mobile) {
        try {
            return (await apiService.put(`auth/${mobile}/send-reset-otp`, {}, false)).data;
        }
        catch {
            return { sucess: false, message: 'An error occured while processing the request.' };
        }
    },

    async activateResetCode(data) {
        try {
            return (await apiService.post(`auth/activate-reset-code`, data, false)).data;
        }
        catch {
            return { sucess: false, message: 'An error occured while processing the request.' };
        }
    },

     async submitNewPassword(data) {
        try {
            return (await apiService.post(`auth/submit-new-password`, data, false)).data;
        }
        catch {
            return { sucess: false, message: 'An error occured while processing the request.' };
        }
    },

    async resendCode() {
        try {
            return (await apiService.get(`auth/resend-code`, {}, true)).data;
        }
        catch {
            return { sucess: false, message: 'An error occured while processing the request.' };
        }
    },

    
    async resendResetCode(token) {
        try {
            return (await apiService.get(`auth/${token}/resend-reset-code`, {}, false)).data;
        }
        catch {
            return { sucess: false, message: 'An error occured while processing the request.' };
        }
    },

    async submitLogin(credentials) {
        try {
            return (await apiService.post(`u/submitlogin`, credentials, false)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request" };
        }
    }
};

export default userService;